import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import ProgressivePhoto from '../../../../../../../../../../../components/grid/ProgressivePhoto';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../../../constants/image-size-codes';
import Button from '../../../../../../../../../../../components/global/Button';
import CheckmarkIcon from '../../../../../../../../../../../components/icons/CheckmarkIcon';
import TrashIcon from '../../../../../../../../../../../components/icons/TrashIcon';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  linkTo: PropTypes.string.isRequired,
  onPublish: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  processing: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
const ReviewPhoto = ({
  photo,
  linkTo,
  onPublish,
  onDelete,
  processing,
  children,
}) => {
  const classes = classNames({
    'secondary-photos-view-photos-step-photo': true,
  });

  return (
    <div className={classes}>
      <div className="review-items">
        <Button
          onClick={onPublish}
          btnStyle="reset"
          className="mr-1"
          disabled={processing}
          data-for="publish-only"
          data-place="top"
          data-effect="solid"
          data-tip
        >
          <CheckmarkIcon color="#FFF" size={16} />
          <ReactTooltip id="publish-only">Publish</ReactTooltip>
        </Button>
        <Button
          onClick={onDelete}
          btnStyle="reset"
          className="delete-btn"
          data-for="delete-photo"
          data-place="top"
          data-effect="solid"
          data-tip
        >
          <TrashIcon color="#FFF" size={16} />
          <ReactTooltip id="delete-photo">Delete</ReactTooltip>
        </Button>
      </div>
      <Link to={linkTo}>
        <ProgressivePhoto
          thumbnails={photo.watermarked_urls || photo.thumbnail_urls}
          progressive={false}
          size={IMAGE_SIZE_CODE.MEDIUM2X}
          allowFallbackThumbnail
        />
      </Link>
      {children}
    </div>
  );
};

ReviewPhoto.propTypes = propTypes;

export default ReviewPhoto;
